'use client';

import styled, { css } from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  position: relative;
  max-width: 1400px;

  align-self: center;
  width: calc(100% + 16px);

  margin-bottom: 16px;
  gap: 16px;

  user-select: none;

  @media (max-width: ${breakpoints.mobile}) {
    height: auto;
  }
`;

export const MainContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;
`;

export const VideoWrap = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;

  overflow: hidden;
  border-radius: 22px;

  position: relative;

  @media (max-width: 1720px) {
    border-radius: 0;
  }

  @media (max-width: ${breakpoints.laptop}) {
    background: ${colors.linearBlue};
    height: 60vh;
  }
`;

export const VideoFilter = styled.div`
  display: flex;

  width: 100%;
  height: 100%;

  position: absolute;
  top: 0;
  left: 0;

  background: ${colors.linearBlue};

  background-size: contain;
  transition: opacity 1s ease-in-out;

  @media (min-width: ${breakpoints.laptop}) {
    opacity: ${({ $playing, $clearScreen }) => ($clearScreen ? 0 : $playing ? 0.5 : 1)};
    z-index: 1;
  }

  @media (max-width: ${breakpoints.laptop}) {
    z-index: 1;
    opacity: ${({ $playing, $clearScreen }) => ($clearScreen ? 0 : $playing ? 0.5 : 1)};
  }
`;

export const Controls = styled.div`
  display: flex;
  gap: 16px;

  position: absolute;
  bottom: 16px;
  right: 16px;

  height: 24px;

  color: ${colors.light};

  z-index: 3;

  > svg {
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    top: 16px;
    right: 16px;

    transform: scale(0.8);
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;

  width: 600px;
  height: 250px;

  overflow: visible;

  @media (max-width: ${breakpoints.laptop}) {
    transform: scale(0.8);
  }

  @media (max-width: ${breakpoints.tablet}) {
    transform: scale(0.6);
  }

  @media (max-width: ${breakpoints.mobile}) {
    transform: scale(0.5);
  }

  transition: all 1s ease-in-out;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;

  gap: 20px;
  padding: 0 30px;

  @media (max-width: ${breakpoints.laptop}) {
    padding: 0;
  }
`;

export const Title = styled.h1`
  color: ${colors.light};
  font-weight: 900;

  @media (max-width: ${breakpoints.desktop}) {
    font-size: 3rem;
  }

  @media (max-width: ${breakpoints.laptop}) {
    font-size: 2.5rem;
  }

  @media (max-width: ${breakpoints.tablet}) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.p`
  color: ${colors.brown};
  font-weight: 300;
  font-size: 1.3rem;

  @media (max-width: ${breakpoints.desktop}) {
    font-size: 1.1rem;
  }

  @media (max-width: ${breakpoints.laptop}) {
    font-size: 1rem;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  height: 100%;
  padding: 0 10%;

  position: absolute;
  top: 0;
  left: 0;

  z-index: 2;

  ${({ $clearScreen }) =>
    $clearScreen &&
    css`
      ${LogoContainer} {
        opacity: 0;
        transition: opacity 1s ease-in-out;
      }

      ${Message} {
        opacity: 0;
        transition: opacity 1s ease-in-out;
      }
    `};

  @media (max-width: ${breakpoints.laptop}) {
    flex-direction: column-reverse;
    justify-content: center;

    padding: 0 32px;
    gap: 48px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    height: auto;
    gap: 92px;

    ${({ $clearScreen }) =>
      $clearScreen &&
      css`
        ${Message} {
          opacity: 1;
        }
      `};
  }
`;
